document.addEventListener("DOMContentLoaded", function() {
    
    // --- ФУНКЦИЯ ДЛЯ ПОСЛЕДОВАТЕЛЬНОГО ПРОИГРЫВАНИЯ (How It Works) ---
    function setupVideoSequence(videoIds) {
        const vids = videoIds
            .map(id => document.getElementById(id))
            .filter(v => v !== null);

        if (vids.length === 0) return;

        function playInSequence(index) {
            if (!vids[index]) return;
            vids[index].currentTime = 0;
            const playPromise = vids[index].play();
            if (playPromise !== undefined) {
                playPromise.catch(() => console.log("Autoplay blocked"));
            }
            vids[index].onended = function() {
                let nextIndex = (index + 1) % vids.length;
                playInSequence(nextIndex);
            };
        }
        playInSequence(0);
    }

    // --- ФУНКЦИЯ ДЛЯ КЛИКАБЕЛЬНЫХ ВИДЕО (Slider / Join Us) ---
    function setupClickToPlayVideos() {
        const containers = document.querySelectorAll('.js-video-container');

        containers.forEach(container => {
            const video = container.querySelector('.js-sl-video');
            if (!video) return;

            container.addEventListener('click', function() {
                if (video.paused) {
                    // Останавливаем все другие видео в этой секции, чтобы не было наложения звука
                    document.querySelectorAll('.js-sl-video').forEach(v => {
                        v.pause();
                        v.closest('.js-video-container').classList.remove('is-playing');
                    });

                    video.play();
                    container.classList.add('is-playing');
                } else {
                    video.pause();
                    container.classList.remove('is-playing');
                }
            });

            video.addEventListener('ended', function() {
                container.classList.remove('is-playing');
            });
        });
    }

    // --- ИНИЦИАЛИЗАЦИЯ ВСЕХ СЕКЦИЙ ---

    // Очереди видео (How It Works)
    setupVideoSequence(['step-video-2', 'step-video-3', 'step-video-4']);
    setupVideoSequence(['home-step-video-2', 'home-step-video-3', 'home-step-video-4']);
    setupVideoSequence(['product-step-video-2', 'product-step-video-3', 'product-step-video-4']);
    setupVideoSequence(['mobile-step-video-2', 'mobile-step-video-3', 'mobile-step-video-4']);

    // Слайдер с 5 видео (Клик для запуска)
    setupClickToPlayVideos();
});

